module.exports = __webpack_public_path__ + "static/media/alert.a166317d.svg";